module.exports = require("./es-IC.d.ts");